'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _dateUtils = require('../utils/dateUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbstractCollector = function () {
  function AbstractCollector(openings) {
    _classCallCheck(this, AbstractCollector);

    this._openings = openings;
  }

  _createClass(AbstractCollector, [{
    key: '_toKey',
    value: function _toKey() /* time */{
      throw new Error('#_toKey not implemented');
    }
  }, {
    key: '_fromKey',
    value: function _fromKey() /* key */{
      throw new Error('#_fromKey not implemented');
    }
  }, {
    key: '_getRange',
    value: function _getRange() /* startTime, endTime */{
      throw new Error('#_getRange not implemented');
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var _this = this;

      var times = Object.keys(this._getMap()).map(function (key) {
        return _this._fromKey(key);
      });
      if (times.length > 1) {
        var sortedTimes = (0, _dateUtils.sortTimes)(times);
        return this._getRange(sortedTimes[0], sortedTimes[sortedTimes.length - 1]);
      }
      return times;
    }
  }, {
    key: 'filterBy',
    value: function filterBy(time) {
      var key = this._toKey(time);
      var value = this._getMap()[key];
      return value == null ? [] : value;
    }
  }, {
    key: 'forEach',
    value: function forEach(callback) {
      var _this2 = this;

      return this.getRange().map(function (rangeValue, index) {
        return callback(rangeValue, _this2.filterBy(rangeValue), index);
      });
    }
  }, {
    key: '_getMap',
    value: function _getMap() {
      var _this3 = this;

      if (this._map == null) {
        this._map = this._openings.reduce(function (memo, opening) {
          var key = _this3._toKey(opening.time);
          if (memo[key] == null) {
            // eslint-disable-next-line no-param-reassign
            memo[key] = [];
          }
          memo[key].push(opening);
          return memo;
        }, {});
      }
      return this._map;
    }
  }]);

  return AbstractCollector;
}();

var DateCollector = function (_AbstractCollector) {
  _inherits(DateCollector, _AbstractCollector);

  function DateCollector(openings /* , options */) {
    _classCallCheck(this, DateCollector);

    var _this4 = _possibleConstructorReturn(this, (DateCollector.__proto__ || Object.getPrototypeOf(DateCollector)).call(this, openings));

    _this4._format = 'YYYY-MM-DD';
    return _this4;
  }

  _createClass(DateCollector, [{
    key: '_toKey',
    value: function _toKey(date) {
      return date.format(this._format);
    }
  }, {
    key: '_fromKey',
    value: function _fromKey(key) {
      return (0, _momentTimezone2.default)(key, this._format);
    }
  }, {
    key: '_getRange',
    value: function _getRange(startDate, endDate) {
      return (0, _dateUtils.getDateRange)(startDate, endDate);
    }
  }]);

  return DateCollector;
}(AbstractCollector);

var TimeCollector = function (_AbstractCollector2) {
  _inherits(TimeCollector, _AbstractCollector2);

  function TimeCollector(openings) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        timeZone = _ref.timeZone,
        _ref$interval = _ref.interval,
        interval = _ref$interval === undefined ? 30 : _ref$interval;

    _classCallCheck(this, TimeCollector);

    var _this5 = _possibleConstructorReturn(this, (TimeCollector.__proto__ || Object.getPrototypeOf(TimeCollector)).call(this, openings));

    _this5._timeZone = timeZone;
    _this5._interval = interval;
    _this5._format = 'HH:mmZ';
    return _this5;
  }

  _createClass(TimeCollector, [{
    key: '_toKey',
    value: function _toKey(time) {
      var timeWithZone = this._applyTimeZone(time);
      return this._floorTime(timeWithZone, this._interval).format(this._format);
    }
  }, {
    key: '_fromKey',
    value: function _fromKey(key) {
      return this._applyTimeZone((0, _momentTimezone2.default)(key, this._format));
    }
  }, {
    key: '_getRange',
    value: function _getRange(startTime, endTime) {
      var start = this._floorTime(startTime, 60);
      var end = this._ceilTime(endTime, 59);
      return (0, _dateUtils.getTimeRange)(start, end, { interval: this._interval });
    }
  }, {
    key: '_floorTime',
    value: function _floorTime(time, interval) {
      var minutes = time.minutes();
      minutes -= minutes % interval;
      return this._applyTimeZone((0, _momentTimezone2.default)(time).minute(minutes));
    }
  }, {
    key: '_ceilTime',
    value: function _ceilTime(time, interval) {
      var minutes = time.minutes();
      minutes += interval - minutes % interval;
      return this._applyTimeZone((0, _momentTimezone2.default)(time).minute(minutes));
    }
  }, {
    key: '_applyTimeZone',
    value: function _applyTimeZone(time) {
      if (this._timeZone != null) {
        return (0, _momentTimezone2.default)(time).utcOffset(this._timeZone);
      }
      return time;
    }
  }]);

  return TimeCollector;
}(AbstractCollector);

var OpeningCollection = function () {
  function OpeningCollection(openings) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, OpeningCollection);

    this._openings = openings;
    this._options = options;
  }

  _createClass(OpeningCollection, [{
    key: 'getDateRange',
    value: function getDateRange() {
      return this._getDateCollector().getRange();
    }
  }, {
    key: 'filterByDates',
    value: function filterByDates(dates) {
      var _this6 = this;

      return dates.reduce(function (memo, date) {
        return memo.concat(_this6.filterByDate(date));
      }, []);
    }
  }, {
    key: 'filterByDate',
    value: function filterByDate(date) {
      return this._getDateCollector().filterBy(date);
    }
  }, {
    key: 'forEachDate',
    value: function forEachDate(callback) {
      return this._getDateCollector().forEach(callback);
    }
  }, {
    key: 'getTimeRange',
    value: function getTimeRange() {
      return this._getTimeCollector().getRange();
    }
  }, {
    key: 'filterByTime',
    value: function filterByTime(time) {
      return this._getTimeCollector().filterBy(time);
    }
  }, {
    key: 'forEachTime',
    value: function forEachTime(callback) {
      return this._getTimeCollector().forEach(callback);
    }
  }, {
    key: '_getDateCollector',
    value: function _getDateCollector() {
      if (this._dateCollector == null) {
        this._dateCollector = new DateCollector(this._openings);
      }
      return this._dateCollector;
    }
  }, {
    key: '_getTimeCollector',
    value: function _getTimeCollector() {
      if (this._timeCollector == null) {
        this._timeCollector = new TimeCollector(this._openings, {
          timeZone: this._options.timeZone,
          interval: this._options.interval
        });
      }
      return this._timeCollector;
    }
  }]);

  return OpeningCollection;
}();

exports.default = OpeningCollection;